import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import { useEffect, useState } from 'react';
import { Outlet, useNavigation } from 'react-router';
import { APP_INFO } from '#src/app/app-info';
import { Sidebar } from '#src/app/shell/Sidebar';
import { TopBar } from '#src/app/shell/TopBar';
import { LoadingState } from '#src/shared/ui';
import { useMediaQuery } from '#src/shared/useMediaQuery';

/** Abaixo disto a navegação vira gaveta (Teams no celular, painel estreito). */
const COMPACT = '(max-width: 768px)';
const COLLAPSED_KEY = 'arquivo-morto.nav.collapsed';

const VEIL = `color-mix(in srgb, ${tokens.colorNeutralBackground3} ${APP_INFO.identityArtVeil}%, transparent)`;

const useStyles = makeStyles({
  root: {
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    // Fundo neutro e chapado, como o do Teams: os cartões brancos se separam
    // dele pela sombra.
    backgroundColor: tokens.colorNeutralBackground3,
    color: tokens.colorNeutralForeground1,
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    flexBasis: 0,
    minWidth: 0,
  },
  // Arte de identidade sob um véu da cor do tema, para o conteúdo seguir legível.
  identityArt: {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  content: { flexGrow: 1, minHeight: 0, overflowY: 'auto' },
});

/** A preferência de barra recolhida é de cada pessoa, neste navegador. */
function readCollapsed(): boolean {
  try {
    return localStorage.getItem(COLLAPSED_KEY) === '1';
  } catch {
    return false;
  }
}

function saveCollapsed(collapsed: boolean): void {
  try {
    localStorage.setItem(COLLAPSED_KEY, collapsed ? '1' : '0');
  } catch {
    // Sem armazenamento, a barra só volta expandida na próxima visita.
  }
}

export function AppShell() {
  const styles = useStyles();
  const compact = useMediaQuery(COMPACT);
  // Tela estreita: gaveta sobre a página. Larga: barra fixa, expandida ou só ícones.
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(readCollapsed);
  const loadingPage = useNavigation().state === 'loading';

  useEffect(() => {
    if (!compact) {
      setDrawerOpen(false);
    }
  }, [compact]);

  const art = APP_INFO.identityArt;

  return (
    <div className={styles.root}>
      <Sidebar
        overlay={compact}
        open={drawerOpen}
        onOpenChange={setDrawerOpen}
        collapsed={collapsed}
        onCollapsedChange={(value) => {
          saveCollapsed(value);
          setCollapsed(value);
        }}
      />
      <div
        className={mergeClasses(
          styles.main,
          art !== null && styles.identityArt,
        )}
        style={
          art === null
            ? undefined
            : {
                backgroundImage: `linear-gradient(${VEIL}, ${VEIL}), url("${art}")`,
              }
        }
      >
        <TopBar showMenu={compact} onOpenMenu={() => setDrawerOpen(true)} />
        <main className={styles.content}>
          {loadingPage ? <LoadingState /> : <Outlet />}
        </main>
      </div>
    </div>
  );
}
